import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb } from 'lucide-react';
export function StorySection() {
  return <section className="py-12 md:py-16 bg-amber-50/50 text-teal-900" data-id="element-246">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-247">
        <div className="text-center mb-8" data-id="element-248">
          <h2 className="text-3xl font-bold mb-6 text-amber-600" data-id="element-249">
            LA HISTORIA QUE LO CAMBIA TODO
          </h2>
        </div>

        <div className="bg-white border border-stone-100 rounded-3xl p-8 mb-8 text-center shadow-sm" data-id="element-250">
          <p className="text-lg text-stone-600 leading-relaxed mb-4" data-id="element-251">
            Nadie espera que un niño hable antes de entender el lenguaje. Nadie
            espera que corra antes de aprender a caminar.
          </p>
          <p className="text-xl font-bold text-amber-600" data-id="element-252">
            La comunicación funciona exactamente igual.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-amber-100/50 text-teal-900 rounded-2xl p-6 shadow-sm border border-amber-200 flex items-start gap-4" data-id="element-253">
          <Lightbulb className="w-8 h-8 flex-shrink-0 mt-1 text-amber-600" data-id="element-254" />
          <div data-id="element-255">
            <p className="font-bold mb-2" data-id="element-256">
              Primero imágenes, después rutinas, después emociones y, por
              último, autonomía.
            </p>
            <p className="text-sm text-stone-700 mt-2" data-id="element-257">
              El cerebro con TEA no rechaza el mundo: rechaza la incertidumbre.
              Cuando no sabe qué viene, activa la alarma y la crisis es
              inevitable.
            </p>
            <p className="text-sm font-semibold text-teal-800 mt-2" data-id="element-258">
              El Método de Anticipación Visual 360° le da un sistema visual
              claro que le dice: "Sabés lo que viene. Estás seguro."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}